import React from "react";
import type { ObjectRefPreviewAttribute } from "../../types/types.PIM";
import { ReferenceHoverTooltip } from "../ReferenceHoverTooltip";

export function getObjectReferenceDetailPath(
  adminPath: string,
  objectType: string,
  id: string,
  objectNumber?: string | null
): string {
  switch (objectType) {
    case "product":
      return `${adminPath}/pim/products/${objectNumber ?? id}`;
    case "supplier":
      return `${adminPath}/mdm/suppliers/${id}`;
    case "customer":
      return `${adminPath}/mdm/customers/${id}`;
    case "distributor":
      return `${adminPath}/mdm/distributors/${id}`;
    default:
      return `${adminPath}/pim/products/${id}`;
  }
}

type ObjectReferencePreviewTooltipProps = {
  tooltipId: string;
  previewAttributes: ObjectRefPreviewAttribute[];
  children: React.ReactElement;
};

export function ObjectReferencePreviewTooltip({
  tooltipId,
  previewAttributes,
  children,
}: ObjectReferencePreviewTooltipProps) {
  return (
    <ReferenceHoverTooltip
      tooltipId={tooltipId}
      enabled={previewAttributes.length > 0}
      placement="top"
      variant="preview"
      content={
        <ul className="multiselect_tooltip_list">
          {previewAttributes.map((attr) => (
            <li
              className="multiselect_tooltip_list_item"
              key={`${attr.label}-${attr.value}`}
            >
              {attr.label}: {attr.value}
            </li>
          ))}
        </ul>
      }
    >
      {children}
    </ReferenceHoverTooltip>
  );
}
